<app-confirmation-dialog [props]="confirmationDialogProps" id="doc-wallets-modal-dialog">
  <div class="wallets-modal-content" id="doc-wallets-modal-content">
    <div id="doc-wallets-modal-header-info">
      <span id="doc-wallets-modal-span-name"><b i18n="@@name">Nombre:</b> {{name}}</span>
      @if (personType === 'PERSON') {
        <span id="doc-wallets-modal-span-person-info"><b i18n="@@id">Identificación</b>: {{document | cpfMask }}</span>
      }
      @if (personType === 'COMPANY') {
        <span id="doc-wallets-modal-span-company-info"><b i18n="@@id">Identificación</b>: {{document | cnpjMask }}</span>
      }
    </div>
    <ul class="list-group wallets-container" id="doc-wallets-modal-list">
      @for (wallet of wallets; track wallet; let i = $index) {
        <li class="list-group-item" id="doc-wallets-modal-list-item-{{i}}"> {{wallet.walletName}} </li>
      }
    </ul>
  </div>
</app-confirmation-dialog>
